export default __webpack_public_path__ + "static/media/Path 10919.ce38e9bc.svg";